/// <reference path="CustomerBuilder.ts" />

namespace SPA
{
	export namespace Customer
	{
		export namespace gui
		{

			export class ClientCustomerBuilder
				extends SPA.Customer.gui.CustomerBuilder<Wollmilch.ClientObject>
			{
				private obj: Wollmilch.ClientObject;
				private CNO: string;
				private	m_CustomerInputs:	ui.Form.BasicInputField[];
				private m_Form: ui.Form.Form;
				private	m_Box: ui.Box.Box;

				constructor( obj: Wollmilch.ClientObject, CNO: string )
				{
					super( obj );

					this.m_CustomerInputs = [];
					this.m_Box = new ui.Box.Box();

					this.obj = obj;
					this.CNO = CNO;

					this.m_Form = new ui.Form.Form(
						{
							classes: [ 'form-horizontal' ],
							action: 'organization/edit/' + this.obj.ID,
							method: 'PATCH',
							static: true,
							editButtonContext: 'primary',
							submit: ( method: ui.Form.FormMethod, action: string, parameter: ui.Form.IFormParameter ) =>
							{
								new Wollmilch.AJAX(
									{
										method,
										url: action,
										data: parameter,
										on:
										{
											success: ( text: string ): void =>
											{
												let obj: Wollmilch.ResponseObject|null;
												try
												{
													obj = Wollmilch.jsonize( text );
												}
												catch ( e )
												{
													app.addNotify(
														{
															title: [ ui.h( 3, app.getMessage( 'Customer.Edit.TITLE' ) ) ],
															body: [ ui.text( app.getMessage( 'Customer.Edit.FAILED' ) ) ],
															context: 'warning',
															timeout: Number(app.getConfigValue("ToastTimeout"))
														}
													);

													return;
												}
												if ( obj)
												{
													if ( !obj.success && obj.error )
													{
														app.addNotify(
															{
																title: [ ui.h( 3, app.getMessage( 'Customer.Edit.TITLE' ) ) ],
																body: [ ui.text( app.getMessage( 'Customer.Edit.FAILED' ) ) ],
																context: 'warning',
																timeout: Number(app.getConfigValue("ToastTimeout"))
															}
														);

														return;
													}
													
													app.addNotify(
														{
															title: [ ui.h( 3, app.getMessage( 'Customer.Edit.TITLE' ) ) ],
															body: [ ui.text( app.getMessage( 'Customer.Edit.SUCCESS' ) ) ],
															context: 'success',
															timeout: Number(app.getConfigValue("ToastTimeout"))
														}
													);
												}
											}
										}
									},
								).send();
							}
						}
					);
					
					this.m_Form.Initialize();
				}

				public rebuild( root: JQuery|ui.base.BaseHTMLElement ): ClientCustomerBuilder
				{
					root = root instanceof ui.base.BaseHTMLElement ? root.Root() : root;

					this.m_Form.rebuild( root.empty() );

					this.showClientData( root );
					this.showAddressData( root );

					new ui.Box.Box()
						.append( $( this.m_Form.Buttons.submit.getElement() ).text( app.getMessage( 'Aux.SAVE_BTN' ) ) )
						.append( $( this.m_Form.Buttons.cancel.getElement() ).text( app.getMessage( 'Aux.ABORT_BTN' ) ) )
					.appendTo(root);

					return this;
				}

				private showClientData( root: JQuery|ui.base.BaseHTMLElement ): void
				{
					this.m_Box.addTitle( this.obj.Name + ' ' + this.obj.Surname + ' (Knd-Nr.: ' + this.CNO + ')' );
					this.m_Box.rebuild( ui.$$.div().addClass( 'row' )).appendTo( this.m_Form );

					const addCustomerInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) =>
					{
						this.m_CustomerInputs.push( input );
						this.m_Form.Input( input );
						input.Base().addClass( baseclass.join( ' ' ) );
					};

					this.m_Box.append( ui.$$.h( 4, app.getMessage( 'Aux.BASIC.TRANSLATION.customer' ) ).addClass( 'text-muted' ) );

					const fg = ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.m_Form.Root() );

					let gender = this.obj.Gender;
					if (gender.toString() == '1' || gender.toString() == '0')
					{
						gender = gender.toString() == '1' ? 'f' : 'm';
					}

					addCustomerInput(
						new ui.Form.Select(
							{
								blank: app.getMessage( 'Aux.PERSON.DESCRIPTION.gender' ),
								option:
								{
									m: app.getMessage( 'Aux.PERSON.SALUTATION.m' ),
									f: app.getMessage( 'Aux.PERSON.SALUTATION.f' )
								},
								name: 'Gender',
								required: true
							}
						).value( gender ).rebuild( fg.append( ui.$$.label().text( app.getMessage( 'Aux.PERSON.DESCRIPTION.gender' ) + app.getMessage( 'Aux.wildcard' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_Box.Root() ) ),
						[ 'col-xs-12', 'col-md-4' ]
					);

					addCustomerInput(
						new ui.Form.Select(
							{
								option:
								{
									'': '',
									'Dr.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.dr' ),
									'Prof.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.prof' ),
									'Prof. Dr.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.profdr' )
								},
								name: 'Salutation'
							}
						).value(this.obj.Title).rebuild( fg.append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.salutation' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_Box.Root() ) ),
						[ 'col-xs-12', 'col-md-4' ]
					);

					addCustomerInput(
						new ui.Form.TextInput(
							this.obj.Name,
							{
								name: 'Name',
								placeholder: app.getMessage( 'Aux.PERSON.DESCRIPTION.name' ),
								required: true
							}
						).rebuild( ui.$$.div().addClass( 'form-group clearfix' )
							.append(
								ui.$$.label()
								.text( app.getMessage( 'Aux.PERSON.DESCRIPTION.name' ) + app.getMessage( 'Aux.wildcard' ) )
								.addClass( 'control-label col-xs-12 col-md-2' )
							)
							.appendTo( this.m_Box.Root() )
						),
						[ 'col-xs-12', 'col-md-10' ]
					);

					addCustomerInput(
						new ui.Form.TextInput(
							this.obj.Surname,
							{
								name: 'Surname',
								placeholder: app.getMessage( 'Aux.PERSON.DESCRIPTION.surname' ),
								required: true
							}
						).rebuild( ui.$$.div().addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Aux.PERSON.DESCRIPTION.surname' ) + app.getMessage( 'Aux.wildcard' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_Box.Root() ) ),
						[ 'col-xs-12', 'col-md-10' ]
					);

					if ( this.obj.Birthday )
					{
						addCustomerInput(
							new ui.Form.DateInput(
								new Date( this.obj.Birthday ),
								'd.m.Y',
								{
									name: 'Birthday',
									required: true
								}
							).rebuild( ui.$$.div().addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Aux.PERSON.DESCRIPTION.birthday' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_Box.Root() ) ),
							[ 'col-xs-12', 'col-md-10' ]
						);
					}

				}

				private showAddressData( root: JQuery|ui.base.BaseHTMLElement ): void
				{
					this.m_Box.append( ui.$$.h( 4, app.getMessage( 'Address.SPECIAL.PostalAddress_Administrative' ) ).addClass( 'text-muted' ) );

					let fg = ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.m_Box.Root() );
					const addCustomerInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { this.m_CustomerInputs.push( input ); this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };

					fg = ui.$$.div().addClass( 'form-group clearfix' ).append(
						ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.Str_HNo' ) + app.getMessage( 'Aux.wildcard' ) ).addClass( 'control-label col-xs-12 col-md-2' )
					).appendTo( this.m_Box.Root() );

					let countPhone = 1;
					this.obj.Address.forEach( (element: any) => {

						switch (element.AddressType)
						{
							case 'PostalAddress':
							{
								addCustomerInput(
									new ui.Form.TextInput(
										element.Street,
										{
											name: 'address.street',
											required: true,
											placeholder: app.getMessage( 'Address.LABEL.LONG.Street' )
										}
									).rebuild( fg ),
									[ 'col-xs-12', 'col-md-7' ]
								);

								addCustomerInput(
									new ui.Form.TextInput(
										element.HouseNumber,
										{
											name: 'address.housenumber',
											required: true,
											placeholder: app.getMessage( 'Address.LABEL.LONG.Housenumber' )
										}
									).rebuild( fg ),
									[ 'col-xs-12', 'col-md-3' ]
								);

								fg = ui.$$.div().addClass( 'form-group clearfix' ).append(
									ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.PC_City' ) + app.getMessage( 'Aux.wildcard' ) ).addClass( 'control-label col-xs-12 col-md-2' )
								).appendTo( this.m_Box.Root() );

								addCustomerInput(
									new ui.Form.TextInput(
										element.PostalCode,
										{
											name: 'address.postalcode',
											required: true,
											placeholder: app.getMessage( 'Address.LABEL.SHORT.Postalcode' )
										}
									).rebuild( fg ),
									[ 'col-xs-12', 'col-md-3' ]
								);

								addCustomerInput(
									new ui.Form.TextInput(
										element.City,
										{
											name: 'address.city',
											required: true,
											placeholder: app.getMessage( 'Address.LABEL.LONG.City' )
										}
									).rebuild( fg ),
									[ 'col-xs-12', 'col-md-7' ]
								);

								fg = ui.$$.div().addClass( 'form-group clearfix' ).append(
									ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.State_Country' ) ).addClass( 'control-label col-xs-12 col-md-2' )
								).appendTo( this.m_Box.Root() );

								addCustomerInput(
									new ui.Form.TextInput(
										element.State,
										{
											name: 'address.state',
											required: false,
											placeholder: app.getMessage( 'Address.LABEL.LONG.State' )
										}
									).rebuild( fg ),
									[ 'col-xs-12', 'col-md-5' ]
								);

								addCustomerInput(
									new ui.Form.TextInput(
										element.Country,
										{
											name: 'address.country',
											required: false,
											placeholder: app.getMessage( 'Address.LABEL.LONG.Country' )
										}
									).rebuild( fg ),
									[ 'col-xs-12', 'col-md-5' ]
								);
								break;
							}
							case 'Phone':
							{
								this.m_Box.append( ui.$$.h( 4, 'Kontaktdaten' ).addClass( 'text-muted' ) );

								fg = ui.$$.div().addClass( 'form-group clearfix' ).append(
									ui.$$.label().text( app.getMessage( 'AddressManager.TYPE_SHORT.Phone' ) + ' ' + countPhone ).addClass( 'control-label col-xs-12 col-md-2' )
								).appendTo( this.m_Box.Root() );

								addCustomerInput(
									new ui.Form.TelInput(
										element.Number,
										{
											name: 'phone' + countPhone + '.value',
											required: false,
											placeholder: app.getMessage( 'AddressManager.TYPE.Phone' )
										}
									).rebuild( fg ),
									[ 'col-xs-12 col-md-10' ]
								);

								addCustomerInput(
									new ui.Form.Select(
										{
											name: 'phone' + countPhone + '.type',
											required: false,
											blank: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.selection' ),
											option:
											{
												home: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.home' ),
												mobile: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.mobile' ),
												office: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.office' )
											}
										}
									).value(element.Type).rebuild( fg ),
									[ 'col-xs-12 col-md-10 col-md-offset-2' ]
								);

								addCustomerInput(
									new ui.Form.Select(
										{
											name: 'phone' + countPhone + '.reachability',
											required: false,
											blank: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.reachability' ),
											option:
											{
												morning: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.morning' ),
												evening: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.evening' ),
												fullday: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.fullday' )
											}
										}
									).value(element.Reachability).rebuild( fg ),
									[ 'col-xs-12 col-md-10 col-md-offset-2' ]
								);

								countPhone++;
								break;
							}
							case 'Email':
							{
								fg = ui.$$.div().addClass( 'form-group clearfix' ).append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.email_title' ) + app.getMessage( 'Aux.wildcard' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_Box.Root() );

								addCustomerInput(
									new ui.Form.EmailInput(
										element.Email,
										{
											name: 'Email.value',
											required: true,
											placeholder: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.email_address' )
										}
									).rebuild( fg ),
									[ 'col-xs-12 col-md-10' ]
								);
								break;
							}
						}
					});

				}

			}
		}
	}
}
